module.exports = __webpack_public_path__ + "img/kej@2x.cd0d3d8c.png";